module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAABAklEQVQ4T53Rr0uYURQG4Odl6Bi4YrItLNjGjBYxWEyCf4LBoGnOjcHiLBPUIhZ/JKvFLiIDQbGZBsNqsxkGwpFPJriPbx+42+655zlc3hOtU1VD+IQZjOIndpJsPm3N00tVDeAc79sDsZVk8bHehp/xvQM9liaS/GgubXiCiR74Mcl6FzzGZA+cT7LdBZtQVnvg2yRXXbAJ5wxjHXg5yVpnOE2xql5hAVNoVvML+0mO+tbxDh/wBr/xAnd4jUvsJbn466tV9RXf2kl3fHkjydLDOqpqDrs9obSfvqSqBnGN4WfA2waO4/QZ6KG1gbM4+B/4EiuYxsifFfxrTpPwDQ7vAc0/Tv5YDZqvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taskPlan/designatedPersonnel.png
// module id = 9+4h
// module chunks = 2